import moment from 'moment';



export default {
    methods:{
        notify(
            title="Alert",
            msg='Notification Created',
            notify_type='alert',
            group='notify',
            ignoreDuplicates=true,
            pauseOnHover=true
        ) {
            this.$notify({
                group: group,
                title: title,
                text: msg,
                type: notify_type,
                duration: 2500,
                ignoreDuplicates: true,
                pauseOnHover: true

            });
        },
        log(value='Log:'){
            return console.log(value);
        },
        checkPasswordStrength() {
            let strengthBadge1 = document.getElementById('StrengthDisp1');
            let strengthBadge2 = document.getElementById('StrengthDisp2');
            let strengthBadge3 = document.getElementById('StrengthDisp3');
            // regex
            let strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,})')
            let mediumPassword = new RegExp('((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{4,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{6,}))')

            if(this.password.length !== 0) {
                if(strongPassword.test(this.password)) {
                strengthBadge1.style.backgroundColor = '#3699FF';
                strengthBadge2.style.backgroundColor = '#3699FF';
                strengthBadge3.style.backgroundColor = '#3699FF';
                } 
                else if(mediumPassword.test(this.password)) {
                strengthBadge1.style.backgroundColor = '#3699FF';
                strengthBadge2.style.backgroundColor = '#3699FF';
                }
                else if(this.password.length < 8){
                strengthBadge2.style.backgroundColor = '#E4E6EF';
                strengthBadge3.style.backgroundColor = '#E4E6EF';
                }
                else {
                strengthBadge1.style.backgroundColor = '#3699FF';
                }
            } 
            else {
                strengthBadge1.style.backgroundColor = '#E4E6EF';
                strengthBadge2.style.backgroundColor = '#E4E6EF';
                strengthBadge3.style.backgroundColor = '#E4E6EF';
            }
        },
        formatedAmount: function (value) {
            return new Intl.NumberFormat().format(value);
        },
        capitalizeString(name) {
            name=name.split(' ');
            let newArr = [];
              name.forEach(item => {
                item = item.charAt(0).toUpperCase()+item.slice(1);
                newArr.push(item); 
                });
            return newArr.join(' ');
            
        },
        decimalChecker(value) {
            if (!value) return '';
            value= value.toString();
            let x =value.split('.')[1];
            if( x == '00' ) {
                return parseInt(value).toFixed();
            }
            else{
              return value;
            }
        },
        commaSeprator(value){
            if (value == null) return '';
            value = Number(value).toFixed(2);
            return Number(value).toLocaleString();
        },
        filterInt(value) {
            if(/^(\-|\+)?([0-9]+|Infinity)$/.test(value))
                return Number(value);
            return NaN;
        },
        filterFloat(value) {
            if(/^\d+(\.\d{1,2})?$/.test(value))
                return Number(value);
            return NaN;
        },
        round(value, decimals) {
            if (!value) {
                value = 0;
            }
            if (!decimals) {
                decimals = 0;
            }
            value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
            return value;
        },
        humanReadableTime(value) {
            return moment(value).fromNow();
        },
        isDecimalNumber(value) {
            return typeof value === "number"  && Number(value).toString() === value.toString()  && value % 1 !== 0  && value > 0
        },
        percentage(value, decimals) {
            if(!value) value = 0;
            if(!decimals) decimals = 0;

            value = value * 100;
            return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals) + "%";
        },
        formatDate(date) {
            return moment(date).format("MMM DD, YYYY");
        },
        capitalizeString(name) {
            name=name.split(' ');
            let newArr = [];
              name.forEach(item => {
                item = item.charAt(0).toUpperCase()+item.slice(1);
                newArr.push(item); 
                });
            return newArr.join(' ');
            
        },
        firstUpperthenLower(name) {
            if (!name) return '';
            name=name.toLowerCase();
            return name[0].toUpperCase()+name.slice(1);
        },
        uppercase(v) {
            return v.toUpperCase();
        },
    },
    filters: {
        formatedAmount: function (value) {
            return new Intl.NumberFormat().format(value);
        },
        capitalizeString(name) {
            name=name.split(' ');
            let newArr = [];
              name.forEach(item => {
                item = item.charAt(0).toUpperCase()+item.slice(1);
                newArr.push(item); 
                });
            return newArr.join(' ');
            
        },
        decimalChecker(value) {
            if (!value) return '';
            value= value.toString();
            let x =value.split('.')[1];
            if( x == '00' ) {
                return parseInt(value).toFixed();
            }
            else{
              return value;
            }
        },
        commaSeprator(value){
            if (value == null) return '';
            value = Number(value).toFixed(2);
            return Number(value).toLocaleString();
        },
        filterInt(value) {
            if(/^(\-|\+)?([0-9]+|Infinity)$/.test(value))
                return Number(value);
            return NaN;
        },
        filterFloat(value) {
            if(/^\d+(\.\d{1,2})?$/.test(value))
                return Number(value);
            return NaN;
        },
    },
}


